// CSS Modules - component class name prefix: DownloadButton__

<template>
  <div
    :class="$style.container"
    v-tippy="{
      theme: 'wika light tooltip',
      interactive: true,
      reactive: true,
      placement: 'top',
      flip: false,
      animation: 'fade',
      duration: [200, 600],
      animateFill: false,
      arrow: true,
      zIndex: 10000,
      html: '#downloadButtonLinks-' + id,
      trigger: isMobileDevice ? 'click' : 'mouseenter focus'
    }"
    ref="tippy"
    @init="initTippy"
    @show="forceRerender"
  >
    <Button
      :colour="colour"
      :href="config.urls.url"
      :isLink="config.hideTooltip ? true : false"
      :targetBlank="true"
      :text="
        this.config.metadata.fileType && this.config.metadata.fileSize
          ? `${this.config.metadata.fileType} (${
              this.config.metadata.fileSize
            })`
          : config.title
      "
    />
    <ul
      v-if="config.urls.url && !config.hideTooltip"
      :id="'downloadButtonLinks-' + id"
      :class="$style.downloadLinks"
    >
      <li>
        <WishListLink
          :key="`key-${componentKey}`"
          :config="{
            text: labels.wishlist,
            item: {
              downloads: [
                {
                  url: config.urls.url,
                  flag: config.urls.flag,
                  language: config.urls.language
                }
              ],
              section: section,
              title: config.wishlistTitle,
              types: config.types
            }
          }"
        />
      </li>
      <li>
        <a
          :href="config.urls.url"
          target="_blank"
          @click="
            wtParams &&
              wtTrack(
                { cat: wtParams.doctype },
                {
                  ...wtParams,
                  filename: config.urls.url
                }
              )
          "
        >
          <i class="fas fa-file-alt"></i>
          <span>{{ config.urls.url.split(/\.(?=[^\.]+$)/)[1] }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import Button from "../Button/Button";
import { isMobile } from "mobile-device-detect";
import WishListLink from "../WishListLink/WishListLink.vue";

export default {
  name: "DownloadButton",
  components: {
    Button,
    WishListLink
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    },
    section: String,
    id: {
      type: String,
      default: ""
    },
    labels: {
      type: Object,
      default: () => {}
    },
    colour: {
      type: String,
      default: "blue"
    },
    wtParams: Object
  },
  data() {
    return {
      componentKey: 0,
      isMobileDevice: isMobile,
      wtTrack: window.wtTrack
    };
  },
  methods: {
    initTippy(tippy) {
      tippy.popper.id = "downloadButtonPopper";
    },
    forceRerender() {
      this.componentKey += 1;
    }
  }
};
</script>

<style module lang="scss">
@import "./DownloadButton.scss";
</style>
